module.exports = __webpack_public_path__ + "it_CH-download-cf79dd.webp";